import { Component, Input } from '@angular/core';
import * as _ from 'lodash';
import * as debug from 'debug';
import { ToolsProvider } from '../../providers/tools/tools';

@Component({
  selector: 'user-badge',
  templateUrl: 'user-badge.html',
})
export class UserBadgeComponent {
  log = debug('app:UserBadgeComponent');

  @Input()
  badge: string = '';
  @Input()
  smallIcon = false;
  @Input() user: any = {};

  badges: any[] = [];
  badgeLookup: any = {};

  constructor(public tools: ToolsProvider) {
    this.tools
      .getBadges()
      .then(res => {
        this.badges = res.data;
        this.badgeLookup = _.keyBy(this.badges, 'id');
        this.log('badgeLookup', this.badgeLookup);
      })
      .catch(e => {
        this.log('error getting badges');
      });
  }
}



// WEBPACK FOOTER //
// ./src/components/user-badge/user-badge.ts